import React from 'react';
import { Button, Dropdown, Tab, Tabs, Nav } from 'react-bootstrap';

const LoanRibbenBox = ({customerDetails}) => {

  return (
    <ul className="maindetail-list clearfix">
      <li className="maindetail-item">
        <h3 className="subheading">Loan Id</h3>
        <div className="sub-value">
          <ul className="sub-value-list">
            <li title="">
              {customerDetails.id} <span className={`finance ${customerDetails.lead_type === 'if' ? 'finance-bg' : ''}`}>{customerDetails.lead_type}</span>
            </li>
          </ul>
        </div>
      </li>

      <li className="maindetail-item">
        <h3 className="subheading">Customer Name</h3>
        <div className="sub-value">
          <ul className="sub-value-list">
            <li title="">{customerDetails.pb_full_name || '-'}</li>
          </ul>
        </div>
      </li>

      <li className="maindetail-item">
        <h3 className="subheading">FCI Agent Name</h3>
        <div className="sub-value">
          <ul className="sub-value-list">
            <li title="">{customerDetails?.surveys?.[0]?.assigned_to_name || '-'}</li>
          </ul>
        </div>
      </li>

      <li className="maindetail-item">
        <h3 className="subheading">Requested Created by</h3>
        <div className="sub-value">
          <ul className="sub-value-list">
            <li title="">{customerDetails?.created_by_name || '-'}</li>
          </ul>
        </div>
      </li>

      <li className="maindetail-item">
        <h3 className="subheading">Request Creation Timestamp</h3>
        <div className="sub-value">
          <ul className="sub-value-list">
            <li title="">{customerDetails?.request_created || '-'}</li>
          </ul>
        </div>
      </li>

      <li className="maindetail-item">
        <h3 className="subheading">Task Acknowledged Timestamp</h3>
        <div className="sub-value">
          <ul className="sub-value-list">
            <li title="">{customerDetails?.surveys?.[0]?.acknowledged_date || '-'}</li>
          </ul>
        </div>
      </li>

      <li className="maindetail-item">
        <h3 className="subheading">Task Completion Timestamp</h3>
        <div className="sub-value">
          <ul className="sub-value-list">
            <li title="">{customerDetails?.surveys?.[0]?.completed_date || '-'}</li>
          </ul>
        </div>
      </li>

      <li className="maindetail-item">
        <h3 className="subheading">Overall Status</h3>
        <div className="sub-value">
          <ul className="sub-value-list">
            <li title="" style={{"color": `${customerDetails?.overall_status === 'Pending' ? 'red' : customerDetails.overall_status === 'Cancelled' ? '#FFA340' : '#30b38a'}`}}>{customerDetails?.overall_status || '-'}</li>
          </ul>
        </div>
      </li>
    </ul>
  );
};

export default LoanRibbenBox;
